import { render, staticRenderFns } from "./MenuPageTemplate.vue?vue&type=template&id=718fab83&"
import script from "./MenuPageTemplate.vue?vue&type=script&lang=js&"
export * from "./MenuPageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports